import { isPositiveNumber, reduce } from "et3-type-guards";
import { toSubGroupFromCominParameter } from "../../../../../../helpers/et3-convert-array-sub-group";
import { TKhattabatMessage } from "../../../../../../Types";
import ET3Div from "../../../../../../core/et3-div";
import { withLiteObserverAndTheme } from "../../../../../../core/et3-enhanced-render";
import Et3Margin from "../../../../../../core/et3-ui/ET3Margin";
import Message from "./message";
import { DEFAULT_TIME } from "../../../../../../constants/input-entries-constants";
import { useEffect, useRef } from "react";

const UsersMessages = withLiteObserverAndTheme<{
  messages: TKhattabatMessage[];
}>((props) => {
  const { theme, messages } = props;
  const { colors, unitX, unitY } = theme;
  const scrollRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    if (scrollRef.current != null) {
      const scrollHeight = scrollRef.current.scrollHeight;
      scrollRef.current.scrollTo({
        top: scrollHeight
      });
    }
  }, [messages.length]);
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        width: 1248 * unitX,
        alignItems: "center",
        justifyContent: "flex-start",
        height: 340 * unitY,
        backgroundColor: colors.all.white,
        overflowX: "hidden"
      }}
      ref={scrollRef}
    >
      {toSubGroupFromCominParameter(messages).map((subGroupData) => {
        return (
          <ET3Div
            width={1188}
            height={0}
            alignItems={"center"}
            fDirection={"column"}
            justifyContent={"center"}
            style={{
              minHeight: "unset" //minHeight here should be removed when  minHeight is removed when dynamic Et3Div
            }}
            color={""}
            withShadow={false}
            isExtendable={true}
            isScrollable={false}
            onClick={() => {}}
          >
            {subGroupData.map((khattabatMessage, index) => {
              const isLastInSubGroup = index === subGroupData.length - 1;
              const isKhattabaMessage = isPositiveNumber(
                khattabatMessage.isKhattabaMessage
              );
              const isClientMessage = isPositiveNumber(
                khattabatMessage.isClientMessage
              );
              const reducedMessage = reduce(() => khattabatMessage.message, "");
              const reducedMessageType = reduce(
                () => khattabatMessage.messageType,
                "text"
              );
              const reducedCreatedOn = reduce(
                () => khattabatMessage.createdOn,
                DEFAULT_TIME
              );
              const isSeenMessage = isPositiveNumber(khattabatMessage.isSeen);
              const reducedGender = reduce(
                () => khattabatMessage.senderGender,
                "m"
              );

              return (
                <>
                  <Message
                    isKhattabaMessage={isKhattabaMessage}
                    isLastInSubGroup={isLastInSubGroup}
                    isClientMessage={isClientMessage}
                    message={reducedMessage}
                    messageType={reducedMessageType}
                    createdOn={reducedCreatedOn}
                    isSeen={isSeenMessage}
                    senderGender={reducedGender}
                  />
                  <Et3Margin top={2} bottom={2} left={0} right={0} />
                </>
              );
            })}
            <Et3Margin top={8} bottom={8} left={0} right={0} />
          </ET3Div>
        );
      })}
    </div>
  );
});

export default UsersMessages;
